export default class ToggleShow {
    static init(): void {
        const toggles: NodeListOf<HTMLElement> = document.querySelectorAll('.toggle-show');

        if (toggles.length > 0) {
            toggles.forEach((toggle) => {
                const container: HTMLElement | null = toggle.closest('.toggle-show__area');
                const triggers: NodeListOf<HTMLElement> = toggle.querySelectorAll('.toggle-show__trigger');

                if (container && triggers.length > 0) {
                    const elements = container.querySelectorAll<HTMLElement>('.toggle-element');
                    let isAnimating = false;

                    const show = (trigger: HTMLElement): void => {
                        const target = trigger.dataset.toggletarget;
                        const targetElements = container.querySelectorAll<HTMLElement>(
                            '[data-toggleelement=' + target + ']',
                        );

                        triggers.forEach((item) => {
                            item.classList.remove('toggle-show__trigger--active');
                        });

                        elements.forEach((element) => {
                            element.classList.remove('block', 'toggle-element--leaving');
                            element.classList.add('none');
                        });

                        if (targetElements.length > 0) {
                            targetElements.forEach((element) => {
                                element.classList.remove('none');
                                element.classList.add('block');
                            });
                            trigger.classList.add('toggle-show__trigger--active');

                            // pozici měříme před animací, ta obsah na začátku posouvá dolů
                            this.scrollToContent(toggle, targetElements[0]);

                            targetElements.forEach((element) => {
                                element.classList.add('toggle-element--entering');
                            });

                            // slidery ve skrytém panelu se inicializovaly s nulovou šířkou,
                            // resize je donutí přepočítat rozměry
                            window.dispatchEvent(new Event('resize'));
                        }
                    };

                    if (elements.length > 0) {
                        triggers.forEach((trigger) => {
                            trigger.addEventListener('click', () => {
                                if (isAnimating || trigger.classList.contains('toggle-show__trigger--active')) {
                                    return;
                                }

                                const current = Array.from(elements).find((element) =>
                                    element.classList.contains('block'),
                                );

                                if (!current) {
                                    show(trigger);

                                    return;
                                }

                                // jako u poptávky: aktuální panel nejdřív vybledne, pak se ukáže nový
                                isAnimating = true;

                                const onFadeOut = (event: AnimationEvent): void => {
                                    // animace z vnořených prvků ignorujeme
                                    if (event.target !== current) {
                                        return;
                                    }

                                    current.removeEventListener('animationend', onFadeOut);
                                    show(trigger);
                                    isAnimating = false;
                                };

                                current.classList.remove('toggle-element--entering');
                                current.addEventListener('animationend', onFadeOut);
                                current.classList.add('toggle-element--leaving');
                            });
                        });
                    }
                }
            });
        }
    }

    // Když je začátek nového obsahu nad horním okrajem (uživatel je odscrollovaný níž),
    // posune stránku tak, aby obsah začínal hned pod fixní navigací a sticky přepínačem.
    static scrollToContent(toggle: HTMLElement, content: HTMLElement): void {
        const navbar: HTMLElement | null = document.querySelector('.base-navbar');
        const bar: HTMLElement | null = toggle.closest('.switcher-bar');
        const isSticky = bar !== null && window.getComputedStyle(bar).position === 'sticky';
        const offset = (navbar?.offsetHeight ?? 0) + (isSticky && bar ? bar.offsetHeight : 0);
        const top = content.getBoundingClientRect().top + window.scrollY - offset;

        if (window.scrollY > top) {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
        }
    }
}
